import { Controller } from "@hotwired/stimulus";
import { Swiper } from "swiper";
import { Autoplay } from "swiper/modules";

export default class Carousel extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [Autoplay],
      loop: true,
      spaceBetween: 0,
      slidesPerView: "auto",
      speed: 3000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
    });
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }
}
